import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=11c4d35b&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&id=11c4d35b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c4d35b",
  null
  
)

export default component.exports